var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333496C3.32065 0.333496 0.333984 3.32016 0.333984 7.00016C0.333984 10.6802 3.32065 13.6668 7.00065 13.6668C10.6807 13.6668 13.6673 10.6802 13.6673 7.00016C13.6673 3.32016 10.6807 0.333496 7.00065 0.333496ZM7.00065 12.3335C4.06065 12.3335 1.66732 9.94016 1.66732 7.00016C1.66732 4.06016 4.06065 1.66683 7.00065 1.66683C9.94065 1.66683 12.334 4.06016 12.334 7.00016C12.334 9.94016 9.94065 12.3335 7.00065 12.3335ZM9.58732 4.52683L5.66732 8.44683L4.41398 7.1935C4.15398 6.9335 3.73398 6.9335 3.47398 7.1935C3.21398 7.4535 3.21398 7.8735 3.47398 8.1335L5.20065 9.86016C5.46065 10.1202 5.88065 10.1202 6.14065 9.86016L10.534 5.46683C10.794 5.20683 10.794 4.78683 10.534 4.52683C10.274 4.26683 9.84732 4.26683 9.58732 4.52683Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e86e5ec7450641ddc3443213dac0dd17.svg";
export { ForwardRef as ReactComponent };